import { Component } from 'solid-js'
import { StateMapDisk } from '../../lib/core/state/state_map_disk.enum'

interface Props {
  disk: StateMapDisk,
}

const StateDiskText: Component<Props> = (props) => {
const label = () => props.disk === StateMapDisk.Cloud ? 'Cloud' : 'IndexedDB'
const color = () => props.disk === StateMapDisk.Cloud ? 'badge bg-info' : 'badge bg-secondary'
  return <span class={color()} style={{ "margin-left": "5px" }}>{label()}</span>
}

export default StateDiskText
